import React from 'react';
import {createRoot} from 'react-dom/client';
import ConfirmDialogHost from './ConfirmDialogHost';
import {alertDialog, confirmDialog} from '../actions/confirm';
import '../../../sass/components/confirm-dialog.scss';

const div = document.createElement('div');
document.body.appendChild(div);
createRoot(div).render(<ConfirmDialogHost />);

window.confirmDialog = confirmDialog;
window.alertDialog = alertDialog;
